"use client"

import { useState, useEffect } from "react"
import "./styles.css"

const CharacterDisplay = ({ character, data, isSelected, onSelect }) => {
  const [showAlternateImage, setShowAlternateImage] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    if (!isSelected) {
      setShowAlternateImage(false)
    }
    if (isSelected) {
      setIsAnimating(true)
      const timer = setTimeout(() => {
        setIsAnimating(false)
      }, 600)
      return () => clearTimeout(timer)
    }
  }, [isSelected])

  const handleImageClick = () => {
    setShowAlternateImage(!showAlternateImage)
    onSelect()
  }

  // Determine which image to show
  const imageToShow =
    showAlternateImage && isSelected && data.alternateImage ? data.alternateImage : data.image || "/placeholder.svg"

  return (
    <div
      style={{
        backgroundColor: data.backgroundColor,
        // padding: isSelected ? "2rem 3rem" : "0",
        padding: isSelected ? "1rem 0" : "0",
        // transform:`scale(${isSelected ? 1.2 : 1})`,
      }}
      className={`character-display ${isSelected ? "selected" : ""} ${isAnimating ? "animating" : ""}`}
    >
      <div className={`character-image-container ${isSelected ? "selected" : ""}`} onClick={handleImageClick}>
        <div className={`image-wrapper ${isSelected ? "selected" : ""}`}>
          <img
            src={imageToShow || "/placeholder.svg"}
            alt={`${character.charAt(0).toUpperCase() + character.slice(1)} Character`}
            className={`character-image ${isSelected ? "selected" : ""}`}
            style={{
              objectFit: "contain",
              borderRadius: "0.85rem",
              width: "100%",
              // transform: `scale(${isSelected ? 1.2 : 1})`,
            }}
          />
        </div>
      </div>

      {isSelected && showAlternateImage && (
        <div className="character-details">
          {/* <h1 className="character-name">{data.name}</h1> */}
          {/* <p className="character-description">{data.description}</p> */}
          <p className="character-name" dangerouslySetInnerHTML={{ __html: data.name }} />
          <p className="character-description" dangerouslySetInnerHTML={{ __html: data.description }} />
        </div>
      )}
    </div>
  )
}

export default CharacterDisplay
